import { faTiktok, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faSnapchatGhost } from '@fortawesome/free-brands-svg-icons/faSnapchatGhost';
import { faTwitch } from '@fortawesome/free-brands-svg-icons/faTwitch';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
// import { container } from './ChannelSocial.module.css';
import './ChannelSocial.scss';

const ChannelSocial = ({ channel, color = 'black' }) => (
	<div
		className={'ChannelSocial'}
		style={{
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			fontSize: '14px',
			color: color,
		}}
	>
		{channel.youtube_id ? (
			<a title="YouTube" href={`https://youtube.com/@${channel.youtube_id}`}>
				<FontAwesomeIcon icon={faYoutube} size="2x" />
			</a>
		) : null}
		{channel.instagram_id ? (
			<a title="Instagram" href={`https://instagram.com/${channel.instagram_id}`}>
				<FontAwesomeIcon icon={faInstagram} size="2x" />
			</a>
		) : null}
		{channel.twitter_id ? (
			<a title="Twitter" href={`https://twitter.com/${channel.twitter_id}`}>
				<FontAwesomeIcon icon={faXTwitter} size="2x" />
			</a>
		) : null}
		{channel.facebook_id ? (
			<a title="Facebook" href={`https://facebook.com/${channel.facebook_id}`}>
				<FontAwesomeIcon icon={faFacebookF} size="2x" />
			</a>
		) : null}
		{channel.twitch_id ? (
			<a title="Twitch" href={`https://twitch.tv/${channel.twitch_id}`}>
				<FontAwesomeIcon icon={faTwitch} size="2x" />
			</a>
		) : null}
		{channel.tiktok_id ? (
			<a title="TikTok" href={`https://tiktok.com/@${channel.tiktok_id}`}>
				<FontAwesomeIcon icon={faTiktok} size="2x" />
			</a>
		) : null}
		{channel.snapchat_id ? (
			<a title="Snapchat" href={`https://www.snapchat.com/add/${channel.snapchat_id}`}>
				<FontAwesomeIcon icon={faSnapchatGhost} size="2x" />{' '}
			</a>
		) : null}
	</div>
);

export default ChannelSocial;
